module.exports = __webpack_public_path__ + "static/media/home-iphone.744a44e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/intro/home-iphone.png
// module id = 1290
// module chunks = 0